import * as React from 'react'

import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import CircularProgress from '@mui/material/CircularProgress'
import OutlinedInput from '@mui/material/OutlinedInput'
import Box, { BoxProps } from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import { HeaderBarHeightPixel } from 'components/atomic/organisms/header'
import BackgroundImage from 'components/atomic/atoms/bg-image'
import IconButton from 'components/atomic/atoms/icon-button'
import useDebounce from 'components/hooks/use-debounce'
import Text from 'components/atomic/atoms/text'
import Navbar from 'pages/wiki/navbar'

const HeroWrapper = styled(Box)`
    position: relative;
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    margin-top: ${`${HeaderBarHeightPixel}px`};
`

interface HeroProps extends BoxProps {
    title: string
    description: string
    searchPlaceholder: string
    onSearch: (value: string) => void
    color?: string
}

const Hero = (props: HeroProps) => {
    const [searchValue, setSearchValue] = React.useState('')
    const searchRef = React.useRef<HTMLInputElement>(null)

    const [debouncedSearchInput] = useDebounce(searchValue, 100)

    React.useEffect(() => {
        props.onSearch(debouncedSearchInput)
    }, [debouncedSearchInput, props])

    const handleClear = () => {
        if (searchRef?.current) {
            searchRef.current.value = ''
            props.onSearch('')
        }
    }

    return (
        <HeroWrapper sx={props.sx}>
            <BackgroundImage filterColor={props.color} imageUrl="/assets/pattern-bg1.png" />

            <Navbar />

            <ResponsiveContainer maxWidth="xl" sx={{ paddingY: 4 }}>
                <Stack spacing={3} width={{ md: '70%', lg: '60%' }}>
                    <Text variant="h2">{props.title}</Text>
                    <Text color="text.secondary">{props.description}</Text>

                    {/** Search */}
                    <OutlinedInput
                        inputRef={searchRef}
                        id="outlined-adornment-weight"
                        size="small"
                        value={searchValue}
                        placeholder={props.searchPlaceholder}
                        startAdornment={
                            <IconButton aria-label="Search" edge="start" color="inherit">
                                <SearchRoundedIcon color="inherit" />
                            </IconButton>
                        }
                        endAdornment={
                            false ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : !!searchRef?.current?.value?.length ? (
                                <Chip
                                    size="small"
                                    onClick={() => handleClear()}
                                    onDelete={() => handleClear()}
                                    label={'Clear'}
                                />
                            ) : null
                        }
                        onChange={(event) => setSearchValue(event.target.value)}
                    />
                </Stack>
            </ResponsiveContainer>
        </HeroWrapper>
    )
}

export default Hero
